(function () {
    'use strict';

    angular
        .module('cacmControlModule', [
            'services.modal'
        ]);
})();
